import { api } from "../api";
import { parseCareTemplate } from "../../parsers/template/parseCareTemplate";
import { CareTemplate } from "../../model/templates/CareTemplate";

export const getAllCareTemplates = async (): Promise<CareTemplate[]> => {
  const result = await api.services.careTemplates.getAllCareTemplates();
  return result.data.map(parseCareTemplate);
};
